<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="用户ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.username" placeholder="用户名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.email" placeholder="邮箱" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.walletAddress" placeholder="钱包地址" />
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-input v-model="filters.companyName" placeholder="公司名" />-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="list"> 查询 </el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="primary" @click="handleAdd"> 新增 </el-button>-->
<!--        </el-form-item>-->
      </el-form>
    </div>

<!--    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="编辑">-->
<!--      <el-form ref="editForm" :model="addForm"  label-width="80px">-->
<!--        <el-form-item label="ID" prop="ID">-->
<!--          <el-input v-model="addForm.id"  />-->
<!--        </el-form-item>-->
<!--        <el-form-item label="用户名" prop="name">-->
<!--          <el-input v-model="addForm.name"  />-->
<!--        </el-form-item>-->
<!--        <el-form-item label="权限级别" prop="Level">-->
<!--          <el-input v-model="addForm.Level" />-->
<!--        </el-form-item>-->
<!--        <el-form-item label="开通时长" >-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            &lt;!&ndash;              <el-input v-model="editForm.PermissionExpiredTime" style="flex: 1; margin-right: 10px;" prop="PermissionExpiredTime" >&ndash;&gt;-->
<!--            &lt;!&ndash;                {{editForm.PermissionExpiredTime | formatDate}}&ndash;&gt;-->
<!--            &lt;!&ndash;              </el-input>&ndash;&gt;-->
<!--            &lt;!&ndash;            <el-input&ndash;&gt;-->
<!--            &lt;!&ndash;              :value="formattedExpireTime"&ndash;&gt;-->
<!--            &lt;!&ndash;              style="width: 60%; margin-right: 20px;"&ndash;&gt;-->
<!--            &lt;!&ndash;              disabled&ndash;&gt;-->
<!--            &lt;!&ndash;            />续费时长：&ndash;&gt;-->
<!--            <el-select v-model="addForm.time" label="开通时长" prop="addExpireTime" placeholder="选择续费时长" @change="addTime">-->
<!--              <el-option label="6个月" value="6" />-->
<!--              <el-option label="1年"   value="12" />-->
<!--              <el-option label="2年"   value="24" />-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="editFormVisible = false">取消</el-button>-->
<!--        <el-button :loading="editLoading" type="primary" @click="editSubmit">提交</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="UserId" label="用户ID" width="150" />
        <el-table-column prop="Username" label="用户名" />
        <el-table-column prop="Email" label="Email" />
        <el-table-column prop="WalletAddress" label="钱包地址" />
<!--        <el-table-column prop="CompanyName" label="所属公司" />-->
        <el-table-column prop="Roles" label="角色" />
        <el-table-column prop="PermissionCreateTime" label="上次修改时间">
          <template slot-scope="scope">
            <!--            <el-input-->
            <!--              :value="formattedExpireTime(scope.row.PermissionCreateTime)"-->
            <!--              style="width: 60%; margin-right: 20px;"-->
            <!--              disabled-->
            <!--            />-->
            {{ scope.row.PermissionCreateTime | formatDate }}
          </template>

        </el-table-column>
        <el-table-column prop="PermissionExpiredTime" label="到期时间">
          <template slot-scope="scope">
            <!--            <el-input-->
            <!--              :value="formattedExpireTime(scope.row.PermissionExpiredTime)"-->
            <!--              style="width: 60%; margin-right: 20px;"-->
            <!--              disabled-->
            <!--            />-->
            {{ scope.row.PermissionExpiredTime | formatDate }}
          </template>

        </el-table-column>
        <el-table-column prop="Level" label="权限等级" width="150" />

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 编辑表单弹窗 -->
      <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑">
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
          <el-form-item label="ID" prop="userId">
            <el-input v-model="editForm.UserId"  readonly/>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="editForm.Username"  readonly/>
          </el-form-item>
          <el-form-item label="所属公司" prop="companyName">
            <el-input v-model="this.companyName"  readonly/>
          </el-form-item>
          <el-form-item label="邮箱地址" prop="email">
            <el-input v-model="editForm.Email"  readonly/>
          </el-form-item>
          <el-form-item label="钱包地址" prop="walletAddress">
            <el-input v-model="editForm.WalletAddress"  readonly/>
          </el-form-item>
          <el-form-item label="权限级别" prop="Level">
            <el-input v-model="editForm.Level" />
          </el-form-item>
          <el-form-item label="起始时间">
            <el-date-picker
              v-model="editForm.startTime"
              type="datetime"
              value-format="timestamp"
              placeholder="选择起始时间"
              style="width: 60%;"
            />
<!--            <div class="tips">默认为当前到期时间；上次填错需要更正、或从旧账号的时间接续时，改这里重算。</div>-->
          </el-form-item>
          <el-form-item label="续费时长">
            <el-select v-model="editForm.addMonth" placeholder="选择续费时长">
              <el-option label="1个月" :value="1" />
              <el-option label="6个月" :value="6" />
              <el-option label="1年"   :value="12" />
              <el-option label="2年"   :value="24" />
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间">
            <el-input
              :value="formattedExpireTime"
              style="width: 60%;"
              disabled
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button :loading="editLoading" type="primary" @click="editSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import {formatDate} from "../../../../filters";

/**
 * 按自然月推进，而不是按 30 天近似。
 * 月末溢出向前收敛：1月31日 + 1个月 = 2月28日，而不是 3月3日。
 */
function addMonths(timestamp, months) {
  const date = new Date(timestamp);
  const day = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() !== day) {
    date.setDate(0);
  }
  return date.getTime();
}

export default {
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        id: "",
        username: "",
        email: "",
        walletAddress: "",
        companyName: "",
      },
      selectedRows: [],
      addForm: {
        id: "",
        name: "",
        Email: "",
        walletAddress: "",
        roles: "",
        Level: "",
        time: "",
      },
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {
        UserId: "",
        Username: "",
        CompanyName: "",
        Email: "",
        WalletAddress: "",
        Roles: "",
        Level: "",
        PermissionExpiredTime: "",
        startTime: "",
        addMonth: "",
      },
      editFormVisible: false,
      editLoading: false,
      companyName:"",
    };
  },
  computed: {
    // 到期时间 = 起始时间 + 续费时长，纯展示，提交时按同一口径换算成 addTime
    expireTime() {
      const start = Number(this.editForm.startTime) || 0;
      if (!start) {
        return 0;
      }
      return addMonths(start, Number(this.editForm.addMonth) || 0);
    },
    formattedExpireTime() {
      return this.expireTime ? formatDate(this.expireTime) : 'nil';
    }
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });

      this.axios
        .form("/api/admin/user-permission/list", params)
        .then((data) => {
          let totalNum = 0
          if (me.page.total !== null){
            totalNum = me.page.total
          }
          me.results = data.results;
          me.page = data.page;
          if (me.page.total === 0){
            me.page.total = totalNum
          }
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleEdit(row) {
      // const params = {
      //   id: row.id,
      // };
      // this.axios
      //   .form("/api/admin/user-permission/find", params)
      //   .then((data) => {
      //     this.editForm.CompanyName= data.companyName;
      //   })
      //   .catch((rsp) => {
      //     this.$notify.error({ title: "错误", message: rsp.message });
      //   });
      const expired = Number(row.PermissionExpiredTime) || 0;
      this.editForm={
        ...row,
        // 起始时间默认取当前到期时间，续费在其之上叠加；
        // 已过期的用户按"从现在起算"给默认值，管理员可以改。
        startTime: Math.max(expired, Date.now()),
        addMonth: ''  // 清空选择框
      }
      const params = { user_id : this.editForm.UserId}
      const me = this;
      this.axios
        .form("/api/admin/user-permission/companyinfo", params)
        .then((data) => {
            me.companyName =data.name;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
      this.editFormVisible = true;
    },
    editSubmit() {
      const start = Number(this.editForm.startTime) || 0;
      if (!start) {
        this.$notify.error({ title: "错误", message: "请选择起始时间" });
        return;
      }
      // 后端按 PermissionExpiredTime + addTime 落库，这里把起始时间作为基准传过去，
      // addTime 是按自然月算出来的差值，保证落库结果和弹窗里预览的到期时间一致。
      const params = {
        ...this.editForm,
        PermissionExpiredTime: start,
        addTime: this.expireTime - start,
      }
      const me = this;
      this.axios
        .form("/api/admin/user-permission/update", params)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    handleAdd(){
      this.addFormVisible = true
    },

  }
}
</script>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
